var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"display":"none"}},_vm._l((_vm.files),function(ref){
var src = ref.src;
return _c('li',[_c('img',{ref:"img",refInFor:true,attrs:{"src":_vm._f("ossThumbnail")(src,75),"alt":src}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9bcfb1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/question-editor/components/image-view-box/src/main.vue
// module id = 1894
// module chunks = 6 47 50